import React from "react";
import { Facebook, Instagram, Linkedin, Mail } from "lucide-react";
import { ASSETS, NAV_LINKS, CONTACT } from "@/data/siteContent";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-dark text-white">
      <div className="container-prose py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={ASSETS.logoBadge} alt="AceMax" className="h-12 w-12 object-contain" />
              <div>
                <div className="font-serif text-2xl text-white">AceMax</div>
                <div className="text-gold text-[10px] tracking-[0.35em] uppercase">Consulting</div>
              </div>
            </div>
            <p className="mt-6 font-serif italic text-xl md:text-2xl text-gold leading-snug max-w-md">
              "Navigating Your Success Starts Here."
            </p>
            <p className="mt-4 text-white/60 text-sm max-w-sm leading-relaxed">
              India's leading sports & education consultancy, guiding families to the world's most
              prestigious universities and boarding schools.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-gold text-[11px] tracking-[0.3em] uppercase mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-white/75 hover:text-gold text-sm transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-gold text-[11px] tracking-[0.3em] uppercase mb-5">Reach Us</p>
            <ul className="space-y-3 text-sm text-white/75">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              {CONTACT.phones.map((p) => (
                <li key={p}>
                  <a href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-gold transition-colors">
                    {p}
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex items-center gap-3">
              {[
                { Icon: Facebook, label: "facebook" },
                { Icon: Instagram, label: "instagram" },
                { Icon: Linkedin, label: "linkedin" },
                { Icon: Mail, label: "email" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href={label === "email" ? `mailto:${CONTACT.email}` : "#"}
                  aria-label={label}
                  data-testid={`social-${label}`}
                  className="w-10 h-10 rounded-full border border-white/15 hover:border-gold hover:bg-gold/10 hover:text-gold flex items-center justify-center transition-all"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© 2025 AceMax Consulting LLP. All rights reserved.</p>
          <p>Crafted with purpose for families chasing global dreams.</p>
        </div>
      </div>
    </footer>
  );
}
